import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { Search } from "@mui/icons-material";
import { Table } from "../common/Table";
import { createForm } from "../../utils/formUtils";
import useForm from "../../hooks/common/useForm";
import useGet from "../../hooks/common/useGet";
import { beautify } from "../../utils/helpers";
import { ussdServicesHooks } from "../../hooks/handlers/useUSSDServicesHandler";
import styled from "styled-components";

interface Props {
  tabKey: string;
}

const USSDServicesLayoutHandler: React.FC<Props> = ({ tabKey }) => {
  const { form, updateFormValues, updateFormValue, onChange } = useForm();
  const { loadData, data, loading } = useGet();
  const [filters, setFilters] = useState({});
  const [hasSearched, setHasSearched] = useState(false);

  const hookConfig = ussdServicesHooks[tabKey]
    ? ussdServicesHooks[tabKey]({
        form,
        updateFormValue,
        updateFormValues,
        onChange,
        filters,
        setFilters,
      })
    : null;

  if (!hookConfig) return <div>No configuration found</div>;

  const {
    searchFields,
    tableColumns,
    tableData,
    api,
    tableTitle,
    initialFilters,
  } = hookConfig;

  useEffect(() => {
    if (initialFilters) {
      setFilters(initialFilters);
    }
  }, []);

  const handleSearch = async (e: any) => {
    e.preventDefault();
    await loadData({
      api,
      params: { ...filters, ...form },
    });
    setHasSearched(true);
  };

  const handleReset = () => {
    updateFormValues({});
    setFilters(initialFilters || {});
    setHasSearched(false);
  };

  const results = data?.results || data || [];
  const totalCount = data?.count || results.length || 0;

  return (
    <Wrapper>
      {searchFields?.length > 0 && (
        <SearchForm onSubmit={handleSearch}>
          <h3>{beautify(tabKey)} Search</h3>

          <FormGrid>
            {createForm(
              [{ title: "", fields: searchFields }],
              form,
              updateFormValues,
              updateFormValue,
              onChange,
              {},
            )}
          </FormGrid>

          <Actions>
            <Button
              type="primary"
              htmlType="submit"
              icon={<Search fontSize="small" />}
            >
              Search
            </Button>
            <Button onClick={handleReset}>Reset</Button>
          </Actions>
        </SearchForm>
      )}

      {hasSearched && (
        <Table
          loading={loading}
          count={totalCount}
          tableTitle={tableTitle}
          tableColumns={tableColumns(results)}
          tableData={tableData(results)}
        />
      )}
    </Wrapper>
  );
};

export default USSDServicesLayoutHandler;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SearchForm = styled.form`
  background: #ffffff;
  padding: 10px 0px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;

  h3 {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    color: #333;
    padding: 10px 15px 0px 15px;
  }
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 0px 20px 10px 0px;
`;
